/**
 * Watches for scroll events on content, and displays the call-to-action
 * button in the header when the inline button is scrolled out of view.
 */
const el = document.getElementById("call-to-action");
const headerBar = document.querySelector("div.menu");
if (el && headerBar) {
    const listener = () => {
        // TODO: Only apply this logic in mobile layout (<600px)
        const visible = el.getBoundingClientRect().bottom < 0;
        headerBar.classList.toggle("show-call-to-action", visible);
    };
    window.addEventListener("scroll", listener, {passive: true});
    listener();
}